import type { components } from '#open-fetch-schemas/api'

export type GenderGroup = components['schemas']['Gender']

export function useEnumGenderGroup() {
  const { $ts: t } = useI18n()

  function getLabel(type: GenderGroup): string {
    switch (type) {
      case 'male':
        return t('Male')
      case 'female':
        return t('Female')
      case 'mixed':
        return t('Mixed')
      case 'aspirants':
        return t('Aspirants')
      case 'juniors':
        return t('Juniors')
      case 'g-darts':
        return t('G-Darts')
      case 'other':
        return t('Other')
      default:
        return ''
    }
  }

  function gendersAsOptions(withMixed: boolean = false): Array<{ value: string, label: string }> {
    const list = [
      {
        value: 'male',
        label: getLabel('male'),
      },
      {
        value: 'female',
        label: getLabel('female'),
      },
      {
        value: 'other',
        label: getLabel('other'),
      },
    ]

    if (withMixed) {
      list.push(
        { value: 'mixed', label: getLabel('mixed') },
        { value: 'aspirants', label: getLabel('aspirants') },
        { value: 'juniors', label: getLabel('juniors') },
        { value: 'g-darts', label: getLabel('g-darts') },
        { value: 'other', label: getLabel('other') },
      )
    }

    return list
  }

  return { getLabel, gendersAsOptions }
}
